import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Public Pages
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import RecordsPage from './pages/RecordsPage';
import BlogPage from './pages/BlogPage';
import HowToApplyPage from './pages/HowToApplyPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ManageRecordHolders from './pages/admin/ManageRecordHolders';
import ManageApplications from './pages/admin/ManageApplications';
import AdminSettings from './pages/admin/AdminSettings';
import ManageFAQs from './pages/admin/ManageFAQs';
import ManageBlogs from './pages/admin/ManageBlogs';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <main className="pt-32">
                  <HomePage />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/about" element={
              <>
                <Header />
                <main className="pt-32">
                  <AboutPage />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/records" element={
              <>
                <Header />
                <main className="pt-32">
                  <RecordsPage />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/blog" element={
              <>
                <Header />
                <main className="pt-32">
                  <BlogPage />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/how-to-apply" element={
              <>
                <Header />
                <main className="pt-32">
                  <HowToApplyPage />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Header />
                <main className="pt-32">
                  <ContactPage />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/faqs" element={
              <>
                <Header />
                <main className="pt-32">
                  <FAQPage />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/record-holders" element={
              <ProtectedRoute>
                <ManageRecordHolders />
              </ProtectedRoute>
            } />
            <Route path="/admin/applications" element={
              <ProtectedRoute>
                <ManageApplications />
              </ProtectedRoute>
            } />
            <Route path="/admin/settings" element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            } />
            <Route path="/admin/faqs" element={
              <ProtectedRoute>
                <ManageFAQs />
              </ProtectedRoute>
            } />
            <Route path="/admin/blogs" element={
              <ProtectedRoute>
                <ManageBlogs />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
